import { Text } from '@innovationdepartment/proxima-ui';
import type { BrandProductCellRendererComponentProps } from '../types';

const BrandProductsRevenuePercentage = (
  props: BrandProductCellRendererComponentProps<'revenuePercentage'>
) => {
  const { value } = props;

  return <Text variant="table1">{`${/(^.*\.\d{3})/.exec(value)?.[0] ?? value}%`}</Text>;
};

export default BrandProductsRevenuePercentage;
